export const removeEvent = (e: React.MouseEvent<HTMLElement, MouseEvent>) =>
  e.stopPropagation();
